import { GET_ADDCHOOSEYOURSERVICE_REQUESTED, GET_CHOOSEYOURSERVICE_REQUESTED, GET_UPDATECHOOSEYOURSERVICE_REQUESTED } from "resources/actionTypes";

export function getChooseYourService (data){
  return {
    type: GET_CHOOSEYOURSERVICE_REQUESTED,
    payload: data,
  }
}

export function postChooseYourService(userAddChooseYourService) {
  const data = {
    userAddChooseYourService: userAddChooseYourService,
  }
  return {
    type: GET_ADDCHOOSEYOURSERVICE_REQUESTED,
    payload: data,
  };
}

export function updateChooseYourService(userUpdateChooseYourService) {
  const data = {
    userUpdateChooseYourService: userUpdateChooseYourService,
  }
  return {
    type: GET_UPDATECHOOSEYOURSERVICE_REQUESTED,
    payload: data,
  };
}